module.exports = __webpack_public_path__ + "static/media/totalPnts_2500_5000.f7edf8f8.png";